import { gql } from "@apollo/client";

export default gql`
  mutation deleteKpiMutation($kpiId: Int!) {
    deleteKpi(kpiId: $kpiId) {
      ok
    }
  }
`;
